import standardAction from '../../../utilities/standard-action';
import { ActionTypes } from '../constants';
import { RootActionTypes } from '../../../stores/types';

export default function newOrgKeyChange(currentValue: string): RootActionTypes {
  return standardAction(ActionTypes.ACCT_ORG_NEW_KEY_CHANGE, currentValue);
}
